module.exports = __webpack_public_path__ + "static/media/icon_settings.72b1cf03.svg";